import { useState } from 'react';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-background-900 via-background-800 to-background-950 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-80 h-80 bg-accent-500/8 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3"></div>
          <div className="absolute bottom-0 left-1/2 w-64 h-64 bg-primary-500/8 rounded-full blur-3xl -translate-x-1/2 translate-y-1/3"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/25 text-accent-300 text-xs font-medium mb-4 whitespace-nowrap">
                移动端观影
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">随时随地，窝在被窝里看电影</h2>
              <p className="text-sm md:text-base text-foreground-300/70 leading-relaxed max-w-md mb-6">
                被窝影院全面适配手机、平板和电脑，无论是在通勤路上、午休间隙还是睡前时光，
                打开浏览器就能享受高清流畅的观影体验。全平台同步观影记录，随时随地接着看。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <a href="#cards" className="px-6 py-3 rounded-lg bg-accent-500 hover:bg-accent-600 text-background-950 font-semibold text-sm whitespace-nowrap flex items-center gap-2 transition-all cursor-pointer">
                  <i className="ri-smartphone-line text-lg"></i>
                  手机端体验
                </a>
                <a href="#features" className="px-6 py-3 rounded-lg border border-background-300/30 hover:border-background-200/60 text-background-200 font-medium text-sm whitespace-nowrap flex items-center gap-2 transition-all cursor-pointer">
                  <i className="ri-computer-line text-lg"></i>
                  电脑端体验
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 w-48 md:w-56">
              {!imgError ? (
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20movie%20streaming%20interface%20on%20dark%20background%20with%20warm%20ambient%20lighting%20cinema%20app%20design%20minimalist%20modern%20UI%20elegant%20presentation%20cozy%20night%20atmosphere&width=500&height=900&seq=app-mockup-01&orientation=portrait"
                  alt="被窝影院移动端界面"
                  className="w-full h-auto"
                  onError={() => setImgError(true)}
                />
              ) : (
                <div className="w-48 h-72 md:w-56 md:h-80 rounded-xl bg-background-700 flex items-center justify-center mx-auto">
                  <i className="ri-smartphone-line text-4xl text-foreground-500"></i>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}